import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { RuleInterface } from '@vendasta/automata/lib';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import { NoRules } from '../../common';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CustomOutputParamsService } from '../../../../component-loader/custom-output-parameters/custom-output-params.service';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { GalaxySnackbarModule, SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { MatIconModule } from '@angular/material/icon';
import { AutomataContextService } from '@galaxy/automata/shared';
import { Context } from '@vendasta/automata';

@Component({
  selector: 'automata-zapier-trigger',
  templateUrl: './zapier-trigger-panel.component.html',
  styleUrls: ['./zapier-trigger-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatAccordion,
    GalaxySnackbarModule,
    MatIconModule,
  ],
})
export class ZapierTriggerPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  context = Context;
  public automationContext = this.automationContextService.currentContext;

  constructor(
    private readonly customOutputParamsService: CustomOutputParamsService,
    private readonly alertService: SnackbarService,
    private readonly automationContextService: AutomataContextService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.savingEnabled$.next(true);
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    return rules;
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return NoRules();
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return this.customOutputParamsService.returnKeyValuesArray.controls as UntypedFormArray[];
  }

  isFormValid(): boolean {
    return true;
  }

  copyText(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      this.alertService.openSuccessSnack(this.translateService.instant('COMMON.COPIED_TO_CLIPBOARD'));
    });
  }
}
